import { App } from '@capacitor/app';
import mitt from 'mitt';

// plugin's methods
const methods = [
	'exitApp',
	'getInfo',
	'getState',
	'getLaunchUrl',
	'minimizeApp',
];

// plugin's listeners
const emitter = mitt();
const events = [
	'appStateChange',
	'appUrlOpen',
	'appRestoredResult',
	'backButton',
];

App.removeAllListeners();

events.forEach(event => {
	App.addListener(event, data => {
		emitter.emit(event, data);
	});
});

export function useNativeApp () {
	// methods
	const api = methods.reduce((api, name) => {
		api[name] = App[name];
		return api;
	}, {});

	// custom add listener
	function addListener (event, callback) {
		emitter.on(event, callback);
		return () => emitter.off(event, callback);
	}

	// custom remove all listeners
	function removeAllListeners () {
		emitter.all.clear();
	}

	return {
		...api,
		addListener,
		removeAllListeners,
	};
};
